import {Box, Button, ButtonText, EmptyState, Text, VStack} from "@hosttools/frontend/components";
import {GluestackUIProvider} from "@hosttools/frontend/components/ui/gluestack-ui-provider";
import type React from "react";
import {useCallback} from "react";

import url from "@/admin/img/sad-face.svg";

type ErrorProps = {
    primaryText?: string;
    secondaryText?: string;
    showEmailMessage?: boolean;
};

const Error: React.FC<ErrorProps> = ({
    primaryText = "An error has occurred",
    secondaryText,
    showEmailMessage = true
}) => {
    const reload = useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <GluestackUIProvider>
            <Box className="h-screen w-full">
                <EmptyState
                    imgAspectRatio="16:9"
                    imgUrl={url}
                    primaryText={primaryText}
                    secondaryText={
                        <VStack space="lg">
                            {secondaryText ? (
                                <Text isParagraph textAlign="center" variant="md">
                                    {secondaryText}
                                </Text>
                            ) : (
                                <Text isParagraph textAlign="center" variant="md">
                                    Please let us know what happened. Send us a message telling us
                                    how this happened so we can fix it
                                </Text>
                            )}
                            {showEmailMessage && (
                                <Text isParagraph textAlign="center" variant="md">
                                    email us:{" "}
                                    <a href="mailto:support@hosttools.com">support@hosttools.com</a>
                                </Text>
                            )}
                        </VStack>
                    }
                >
                    <Button onPress={reload}>
                        <ButtonText>Refresh</ButtonText>
                    </Button>
                </EmptyState>
            </Box>
        </GluestackUIProvider>
    );
};

export default Error;
